import { normalizeLang, type Lang } from "../i18n/i18n";

/** One name for the account-menu entry and billing workspace in every product. */
export const billingNavigationTranslations = {
  de: { title: "Tarif & Abrechnung" },
  en: { title: "Plan & billing" },
  ru: { title: "Тариф и оплата" },
  uk: { title: "Тариф і оплата" },
  it: { title: "Piano e fatturazione" },
} satisfies Record<Lang, { title: string }>;

export function billingNavigationTitle(locale: string): string {
  return billingNavigationTranslations[normalizeLang(locale) ?? "de"].title;
}
